// Third party
import { BrowserRouter } from "react-router-dom";

// Custom Components
import Contexts from "./Contexts";

// Check if route is admin page
const Router = () => {
  return (
    <BrowserRouter>
      <Contexts />
    </BrowserRouter>
  );
};

export default Router;
